module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABP0lEQVQ4T7VVTUuEUBQ9F8UGcmFt+iLahqvGZ7RImr/bD5nZea0IbBcxFK360I0gwg3NMSvJV5obQc8571zvvUdCfbmua5mmuWdZFq2e6dzzPJeiKB7iOM5LfENWSkUApjoiHZhLZq64bUGpgbdFUZwZhhEQ0bnuAcxcaXUJLpg5UEodArgZIvgEYLMWuACwC2BLR1BEXqMo2vjk0Pf9qYgEbdc6YgCEiOZhGJYmPkrWJPfC2t9wB4AnIr8aGyIqmxkx8+PXptwBOKgtPIvIOhGt9Vp6ByyZueJ+67KIXKVpemLbtjIMY6EpiJ/G5jpJkmPHcXwRmQ8RXALY/2PJ98xccf+vKbql9eEah6MPtud5L0TktFavnMvtPkfl+87VU0qt0ma0cGjiK8uy08lkMhsaX+VyH+mUqBWwY/0C3gAY8KYVs5fFwAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/six_active.png
// module id = o56N
// module chunks = 1